export enum ObjStackability {
    SOMETIMES = 0,
    ALWAYS = 1,
    NEVER = 2,
}
